var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col industry al-input pt-2 px-2"},[_c('v-select',{staticClass:"border-none",attrs:{"name":"user_group","options":_vm.industry_options,"clearable":false},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }